module.exports = __webpack_public_path__ + "img/unrisd60-desktop.8ac1e112.png";